import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import apiClient from 'helpers/apiService';
import { getRandomNumber } from 'helpers/utils';
import { FormEvent, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Contact {
  name: string;
  email: string;
}


interface ShareWithContactsModalProps {
  show: boolean;
  onClose: (emails: string[] | null) => void;
}

const ShareWithContactsModal = ({ show, onClose }: ShareWithContactsModalProps) => {

  const [contacts, setContacts] = useState<Contact[]>();
  const [contactsLoading, setContactsLoading] = useState<boolean>(false);
  const [selectedContacts, setSelectedContacts] = useState<{ [email: string]: boolean }>({});

  const { t } = useTranslation();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const selectedEmails = Object.entries(selectedContacts)
      .filter(([_, isSelected]) => isSelected) // Keep only selected entries
      .map(([email]) => email); // Extract the emails
    onClose(selectedEmails);
  };

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setSelectedContacts(prevState => ({
      ...prevState,
      [name]: checked
    }));
  };


  const fetchContacts = async () => {
    try {
      setContactsLoading(true);
      const { data } = await apiClient.get(`/v1/contacts?skip_picture=true`);
      setContacts(data);
      setContactsLoading(false);
    } catch (error) {
      console.error('Error fetching contacts data:', error);
    }
  };


  useEffect(() => {
    fetchContacts();
  }, []);

  return (
    <Modal show={show} onHide={() => onClose(null)} centered contentClassName="border">
      <Form onSubmit={handleSubmit}>
        <Modal.Header className="border-0 p-5">
          <h5 className="modal-title text-1000 fs-6 lh-sm">{t("ShareWithContactsModal.title")}</h5>
          <Button variant="phoenix-secondary" onClick={() => onClose(null)} size="sm">
            <FontAwesomeIcon icon={faTimes} className="text-danger" />
          </Button>
        </Modal.Header>
        <Modal.Body className="px-5 py-0 mb-2">


          {contactsLoading && <div>Loading...</div>}

          {contacts && contacts.map((contact, index) => (
            <Form.Check key={index}>
              <Form.Check.Input
                type="checkbox"
                id={`contact-${index}`}
                name={contact.email} // Use the contact name as the key
                checked={selectedContacts[contact.email] || false}
                onChange={handleCheckChange}
              />
              <Form.Check.Label htmlFor={`contact-${index}`}>{contact.name}</Form.Check.Label>
            </Form.Check>
          ))}

        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end align-items-center border-0 p-5">
          <Button
            variant="link"
            className="px-4 m-0 text-danger"
            onClick={() => onClose(null)}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit" className="px-4 m-0">
            Share
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ShareWithContactsModal;
